/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.0.1
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SourceAttribution
 */
export interface SourceAttribution {
  /**
   *
   * @type {string}
   * @memberof SourceAttribution
   */
  fixitUrl?: string | null;
  /**
   *
   * @type {string}
   * @memberof SourceAttribution
   */
  source: string;
  /**
   *
   * @type {string}
   * @memberof SourceAttribution
   */
  sourceId: string;
}

/**
 * Check if a given object implements the SourceAttribution interface.
 */
export function instanceOfSourceAttribution(
  value: object,
): value is SourceAttribution {
  if (!("source" in value) || value["source"] === undefined) return false;
  if (!("sourceId" in value) || value["sourceId"] === undefined) return false;
  return true;
}

export function SourceAttributionFromJSON(json: any): SourceAttribution {
  return SourceAttributionFromJSONTyped(json, false);
}

export function SourceAttributionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SourceAttribution {
  if (json == null) {
    return json;
  }
  return {
    fixitUrl: json["fixit_url"] == null ? undefined : json["fixit_url"],
    source: json["source"],
    sourceId: json["source_id"],
  };
}

export function SourceAttributionToJSON(json: any): SourceAttribution {
  return SourceAttributionToJSONTyped(json, false);
}

export function SourceAttributionToJSONTyped(
  value?: SourceAttribution | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    fixit_url: value["fixitUrl"],
    source: value["source"],
    source_id: value["sourceId"],
  };
}
